import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { COLORS } from '@fupa/fupa-uikit';
export default function DeleteDialog(_ref) {
  let {
    open,
    onReject,
    onResolve,
    title,
    description
  } = _ref;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    "aria-labelledby": "delete-dialog-title",
    "aria-describedby": "delete-dialog-description",
    "data-sentry-element": "Dialog",
    "data-sentry-component": "DeleteDialog",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "delete-dialog-title",
    "data-sentry-element": "DialogTitle",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, title), /*#__PURE__*/React.createElement(DialogContent, {
    "data-sentry-element": "DialogContent",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, /*#__PURE__*/React.createElement(DialogContentText, {
    id: "delete-dialog-description",
    "data-sentry-element": "DialogContentText",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, description)), /*#__PURE__*/React.createElement(DialogActions, {
    "data-sentry-element": "DialogActions",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    sx: {
      color: COLORS.darkerGrey
    },
    onClick: onReject,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, "Abbrechen"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "error",
    onClick: onResolve,
    autoFocus: true,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "DeleteDialog.tsx"
  }, "L\xF6schen")));
}